window.addEventListener( 'DOMContentLoaded', function() {
	'use strict';
	const readMore = document.querySelector('.readMore');
	if (!readMore) {return;}
	
	const desc = document.querySelector('.description'),
		text = readMore.firstElementChild,
		arrow = readMore.lastElementChild,
	
		lineHeight = parseInt(document.defaultView.getComputedStyle(desc).lineHeight),
		lines = desc.offsetHeight / lineHeight;
	
	if (lines < 6) {return;}
	const collapsedHeight = desc.style.maxHeight = lineHeight * 5 + 'px',
		innerText = [
			'LUK',
			'LÆS MERE'
		],
		rot180 = [
			'add',
			'remove'
		],
		maxHeight = [
			'2000px',
			collapsedHeight
		];
	readMore.style.display = 'block';
	let tog = true;
	
	function click_readMore(ev) {
		tog = +!tog;
		desc.style.maxHeight = maxHeight[tog];
		text.innerText = innerText[tog];
		arrow.classList[
			rot180[tog]
		]('rot180');
	}
	readMore.addEventListener( 'click', click_readMore );
});
